@if (hasOcrChecksContent && ocrChecksDetail) {
    <app-operation-detail-tabs-checks-ocr
        [detail]="ocrChecksDetail"
        [suppressKoOcrInAntifraud]="suppressKoOcrInAntifraud"
        [formMatchChecksDetail]="hasFormMatchCompare ? formChecksDetail : null"
    />
} @else if (hasFormMatchCompare && formChecksDetail) {
    <tec-tile [title]="'OPERATIONS.DETAIL.TABS.CHECKS.COMPARE_INFO' | translate">
        <app-operation-form-checks-compare-info [checksDetail]="formChecksDetail" />
    </tec-tile>
} @else {
    <tec-empty-state
        [title]="'OPERATIONS.DETAIL.TABS.CHECKS.EMPTY' | translate"
        [size]="'default'"
        [type]="'empty'"
    />
}
